module.exports = __webpack_public_path__ + "static/media/undraw_done_a34v.3bd85abc.png";